
import { Backdrop, CircularProgress } from '@material-ui/core'
import React from 'react'

export default function Loading(props: any) {
    const style: any = {
        zIndex: 1000000,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#f4f4f488',
    }
    return (
        <Backdrop open={props.loading} style={style}>
            <CircularProgress color="secondary" />
            <br/>
            <div>{props.text ? props.text : "Saving...."}</div>
        </Backdrop>
    )
}
